module.exports = __webpack_public_path__ + "img/Oak V2 960x1080.ee7671c6.png";